import React from 'react';
import { useSelector } from 'react-redux';
import LicenseMetrics from '../../licenseMetrics';
import TimelineComponent from '../../graphComponents/timelineComponent';
import RankingComponent from '../../graphComponents/rankingComponent';
import ROIComponent from '../../graphComponents/ROIComponent';
import BenchMarkingComponent from '../../graphComponents/benchMarkingComponent';
import '../../licenseAnalyticsPage/FinancePageLayout.css';
import {
  getTotalPlayer,
  getPlayerAverage,
  getInterPlayerCount,
  getPlayersYoyValues,
  getClubValue,
} from '../../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { shortenNumber } from '../../licenseAnalyticsSupport/calculationsUtils';
import { PAGE } from '../../licenseAnalyticsSupport/typeInterfaces';
import { useTranslation } from 'react-i18next';

const convertToYearsMonths = (decimalYears:any) => {
  // Get the whole number part (years)
  const years = Math.floor(decimalYears);

  // Get the fractional part and convert it to months
  const months = Math.round((decimalYears - years) * 12);

  return `${years}Y ${months}M`;
};

const PlayersLayoutPage = React.memo(() => {
  const totalPlayer = useSelector(getTotalPlayer);
  const playerAverage = useSelector(getPlayerAverage);
  const interPlayer = useSelector(getInterPlayerCount);
  const getYOYValues = useSelector(getPlayersYoyValues);
  const [t] = useTranslation();
  const club = useSelector(getClubValue);
  const prefix = club ? t('DC_5_CLUB') : t('AVERAGE');
  return (
    <div className="container">
      <div className="a commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + `${t('TOTAL_PLAYERS')} ${t('In_Last_5_Years')}`}
          spendValue={totalPlayer || '-'}
          metricsValue={getYOYValues.value1}
          showYOY
        />
      </div>
      <div className="b commonBox box1">
        <LicenseMetrics
          title={t('AVERAGE_TIME_AT_ACADEMY')}
          spendValue={convertToYearsMonths(Number(playerAverage?.toFixed(1))) || '-'}
          metricsValue={getYOYValues.value2}
          showYOY
        />
      </div>
      <div className="c commonBox box1">
        <LicenseMetrics
          title={prefix + ' ' + t('YOUTH_International_Players')}
          spendValue={interPlayer || '-'}
          metricsValue={getYOYValues.value3}
          showYOY
        />
      </div>

      <div className="d commonBox">
        <TimelineComponent page={PAGE.PLAYERS} departments={[]} />
        {/* <RankingComponent page={PAGE.PLAYERS} /> */}
        <RankingComponent />
      </div>
      <div className="e commonBox">
        <ROIComponent page={PAGE.PLAYERS} departments={[]} />
      </div>
      <div className="f commonBox">
        <BenchMarkingComponent page={PAGE.PLAYERS} departments={[]} />
      </div>
    </div>
  );
});

export default PlayersLayoutPage;
